export const bgm=require("./sounds/bgm.mp3")